import DeleteStoreModal from '../../../../customized/fresh-watch/components/StoreManager/DeleteStore/DeleteStoreModal';
import { ToggleComponent } from '../../../../featureToggle';
import GroupDelete from './GroupDelete';

export default ToggleComponent(GroupDelete, {
  styledComponentsVariants: {
    'fresh-watch': DeleteStoreModal,
  },
});
